import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Form.css';

const StepForm = () => {
    const [step, setStep] = useState(1);

    const [formData, setFormData] = useState({
        name: '',
        age: '',
        city: '',
        email: '',
        phoneNumber: '',
        question1: '',
        question2: '',
        question3: '',
    });
    const resetForm = () => {
        setFormData({
            name: '',
            age: '',
            city: '',
            email: '',
            phoneNumber: '',
            question1: '',
            question2: '',
            question3: '',
        });
    };

    const [errors, setErrors] = useState({});

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const nextStep = () => {

        switch (step) {
            case 1:
                if (formData.age && formData.city && formData.name && formData.phoneNumber) {
                    setStep(step + 1);
                };

                setErrors(validate1());
                break;
            case 2:
                if (formData.question1) {
                    setStep(step + 1);
                };
                setErrors(validate2());
                break;
            case 3:
                if (formData.question2) {
                    setStep(step + 1);
                };
                setErrors(validate3());
                break;
            case 4:
                if (formData.question3) {
                    setStep(step + 1);
                };
                setErrors(validate4());
                break;
            default:
                break;
        }

    };

    const prevStep = () => {
        setStep(step - 1);
    };

    const validate2 = () => {
        const errors = {};
        if (!formData.question1) {
            errors.question1 = 'به سوال پاسخ دهید';
        }
        return errors;
    }

    const validate3 = () => {
        const errors = {};
        if (!formData.question2) {
            errors.question2 = 'به سوال پاسخ دهید';
        }
        return errors;
    }
    const validate4 = () => {
        const errors = {};
        if (!formData.question3) {
            errors.question3 = 'به سوال پاسخ دهید';
        }
        return errors;
    }

    const validate1 = () => {
        const errors = {};

        if (!formData.name) {
            errors.name = 'نام را وارد کنید';
        }

        if (!formData.age) {
            errors.age = 'سن را وارد کنید';
        }

        if (!formData.city) {
            errors.city = 'شهر را وارد کنید';
        }

        if (!formData.phoneNumber) {
            errors.phoneNumber = 'شماره تلفن را وارد کنید';
        }

        return errors;
    };

    const handleSubmit = async () => {
        // const validationErrors = validate();
        // setErrors(validationErrors);
        try {
            await axios.post('http://localhost:5000/api/ssubmit', formData);
            // alert(response.data);
            toast.success("اطلاعات با موفقیت ارسال شد!");
            resetForm();
            setStep(1);

        } catch (error) {
            console.error('There was an error submitting the form!', error);
            // alert(error);
            toast.error('اطلاعات ارسال نشد. لطفا همه موارد را به درستی وارد کنید!', error);
        }

    };

    switch (step) {
        case 1:
            return (
                <div className='con'>
                    <div className="form-container">
                        <h2>اطلاعات زیر را تکمیل کنید</h2>
                        <input
                            type="text"
                            name="name"
                            placeholder="نام و نام خانوادگی"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        {errors.name && <span style={{ color: 'red' }}>{errors.name}</span>}
                        <input
                            type="number"
                            name="age"
                            placeholder="سن"
                            value={formData.age}
                            onChange={handleChange}
                            required
                        />
                        {errors.age && <span style={{ color: 'red' }}>{errors.age}</span>}
                        <input
                            type="text"
                            name="city"
                            placeholder="شهر"
                            value={formData.city}
                            onChange={handleChange}
                            required
                        />
                        {errors.city && <span style={{ color: 'red' }}>{errors.city}</span>}
                        {/* <input
                            type="email"
                            name="email"
                            placeholder="ایمیل"
                            value={formData.email}
                            onChange={handleChange}
                        /> */}
                        <input
                            type="number"
                            name="phoneNumber"
                            placeholder="شماره تماس"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            required
                        />
                        {errors.phoneNumber && <span style={{ color: 'red' }}>{errors.phoneNumber}</span>}
                        <button onClick={nextStep}>مرحله بعد</button>
                    </div>
                </div>
            );
        case 2:
            return (
                <div className='con'>

                    <div className="form-container">
                        <h2>آیا مواجه حضوری با شهید سلیمانی در سیل 1398 داشته‌اید؟</h2>
                        <label for="question1"> بله یا خیر</label>
                        <textarea
                            id="question1"
                            name="question1"
                            rows="4"
                            required
                            value={formData.question1}
                            onChange={handleChange}
                        ></textarea>
                        {errors.question1 && <span style={{ color: 'red' }}>{errors.question1}</span>}

                        <button onClick={prevStep}>مرحله قبل</button>
                        <button onClick={nextStep}>مرحله بعد</button>
                    </div>
                </div>
            );
        case 3:
            return (
                <div className='con'>

                    <div className="form-container">
                        <h2>آیا عکس و فیلم یا صوتی از حضور شهید سلیمانی در خوزستان دارید؟</h2>
                        <label for="question1"> بله یا خیر</label>
                        <textarea
                            id="question2"
                            name="question2"
                            rows="4"
                            required
                            value={formData.question2}
                            onChange={handleChange}
                        ></textarea>
                        {errors.question2 && <span style={{ color: 'red' }}>{errors.question2}</span>}

                        <button onClick={prevStep}>مرحله قبل</button>
                        <button onClick={nextStep}>مرحله بعد</button>
                    </div>
                </div>
            );
        case 4:
            return (
                <div className='con'>
                    <div className="form-container">
                        <h2>برشی کوتاه از خاطره‌تان در ایام حضور شهید سلیمانی در سیل 1398 در استان خوزستان برای ما بنویسید</h2>
                        {/* <label for="question2">پیام</label> */}
                        <textarea
                            id="question3"
                            name="question3"
                            rows="4"
                            required
                            value={formData.question3}
                            onChange={handleChange}
                        ></textarea>
                        {errors.question3 && <span style={{ color: 'red' }}>{errors.question3}</span>}

                        <button onClick={prevStep}>مرحله قبل</button>
                        <button onClick={handleSubmit}>ارسال</button>
                    </div>
                </div>
            );
        default:
            return <div>Unknown step</div>;
    }
};

export default StepForm;
